import React from "react";
import { MdOutlineArrowForwardIos } from "react-icons/md";

// MainProgram component
export default function MainProgram(props) {
  const { children, onMainProgramClick, isActive, className = "" } = props;

  return (
    <div
      onClick={onMainProgramClick}
      className={`text-lg font-semibold py-4 px-6 w-full flex flex-row items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors ${
        isActive ? "text-primary-color bg-gray-50" : "text-gray-700"
      } ${className}`}
    >
      <h2 className="text-left">{children}</h2>
      <MdOutlineArrowForwardIos
        className={`transition-transform duration-200 ${
          isActive ? "rotate-90 text-primary-color" : "text-gray-400"
        }`}
      />
    </div>
  );
}
